<template>
  <div class="p-form-element-messages">
    <p-slide-y-transition>
      <div v-if="hasErrors" class="errors">
        <span>{{ errorsString }}</span>
      </div>
    </p-slide-y-transition>
    <p-slide-y-transition>
      <div v-if="hasMessages" class="messages">
        <span>{{ messagesString }}</span>
      </div>
    </p-slide-y-transition>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      messages: { type: [String, Array], default: undefined },
      errors: { type: [String, Array], default: undefined },
    },
    data: () => ({
      innerErrors: undefined as string | string[] | undefined,
      innerMessages: undefined as string | string[] | undefined,
    }),
    computed: {
      hasMessages(): boolean {
        if (Array.isArray(this.messages)) {
          return this.messages.length > 0;
        }
        return !!this.messages && this.messages !== '';
      },
      hasErrors(): boolean {
        if (Array.isArray(this.errors)) {
          return this.errors.length > 0;
        }
        return !!this.errors && this.errors !== '';
      },
      messagesString(): string {
        if (Array.isArray(this.innerMessages)) {
          // TODO: List messages nicely
          return this.innerMessages.join(', ');
        }
        return this.innerMessages as string;
      },
      errorsString(): string {
        if (Array.isArray(this.innerErrors)) {
          // TODO: List errors nicely
          return this.innerErrors.join(', ');
        }
        return this.innerErrors as string;
      },
    },
    watch: {
      messages: {
        immediate: true,
        handler() {
          this.innerMessages = this.messages as any;
        },
      },
      errors: {
        immediate: true,
        handler() {
          this.innerErrors = this.errors as any;
        },
      },
    },
    methods: {
      setMessages(messages: string | string[]) {
        this.innerMessages = messages;
      },
      setErrors(errors: string | string[]) {
        this.innerErrors = errors;
      },
    },
  });
</script>
